<div class="relative">
    <span class="absolute white adjust pointer" (click)="close()"><svg class="c-svg c-svg--close-24"><use xlink:href="#c-svg--close-24"></use></svg></span>
    <video [src]="maskService.maskMp4Url" (error)="onVideoError()" autoplay loop muted></video>
</div>
